import { Routes, Route } from "react-router-dom";
import AppMain from "./AppMain";
import NotFound from "./NotFound";
import LeaderboardPage from "./LeaderboardPage";
import CreateMarketPage from "./CreateMarketPage";
import MarketResolutionAdminPage from "./MarketResolutionAdminPage";
import CommunitiesPage from "./CommunitiesPage";
import CommunityDetailPage from "./CommunityDetailPage";
import CreateCommunityPage from "./CreateCommunityPage";
import OpenOrdersPage from "./OpenOrdersPage";
function App() {
  return (
    <Routes>
        <Route path="/" element={<AppMain/>}/>
        <Route path="/open-orders" element={<OpenOrdersPage/>}/>
        <Route path="/communities" element={<CommunitiesPage/>}/>
        <Route path="/communities/new" element={<CreateCommunityPage/>}/>
        <Route path="/communities/:communityId" element={<CommunityDetailPage/>}/>
        <Route path="/leaderboard" element={<LeaderboardPage/>}/>
        <Route path="/markets/new" element={<CreateMarketPage/>}/>
        <Route path="/market-resolution" element={<MarketResolutionAdminPage/>}/>
        <Route path="/market-resolution-admin" element={<MarketResolutionAdminPage/>}/>
        <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
